<label class="checkbox" [ngClass]="{ checked: checked }">
  <input
    type="checkbox"
    [checked]="checked"
    (change)="checkboxChanged($event)"
    [value]="value"
  />
  {{ checked ? "✓" : "" }} <ng-content></ng-content>
</label>
